import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quilleditor";
import DatePicker from "../../../Components/DatePicker/datePicker";
import SectionToolbar from "../../../Components/GlobalSectionToolbar/SectionToolbar";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import parse from "html-react-parser";

import { Project1 } from "./Header/ProjectHeader";
import { Volunteer1 } from "./Header/VolunteeringHeader";
// import { OnlinePresence1 } from "./Header/OnlinePresenceHeader";
import { Certifications1 } from "./Header/CertificationsHeader";
// import { References1 } from "./Header/ReferencesHeader";
import { Publications1 } from "./Header/PublicationsHeader";
// import { Books1 } from "./Header/BooksHeader";
import { AdditionalExperienceHeader1 } from "./Header/AdditionalExperienceHeader";
// import { AdditionalSkillsHeader1 } from "./Header/AdditionalSkillsHeader";
// import { CoursesHeader1 } from "./Header/CoursesHeader";
// import { IndustryExpertiseHeader1 } from "../CommonTextComponents/Header/IndustryExpertiseHeader";
// import { TechStackHeader1 } from "./Header/TechStackHeader";

function Project(props) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeHandler,
    resumeUpdate,
    dateHandler,
    styles,
    settings,
  } = props;
  const [t, i18n] = useTranslation("common");
  const { json, setJson, jsonIndex, setJsonIndex, isJson, setIsJson } =
    useContext(jsonEditorContext);

  const editorSettings = useSelector(
    (state) => state.editorData.editorSettings
  );

  // const { education } = settings;

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  const [showSettings, setShowSettings] = useState(false);
  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isSelectedFrom, setIsSelectedFrom] = useState(true);

  //UseForm

  const { showHideElements } = ResumeSubUseForm(props.sectionId);

  const { sectionMoveUp, sectionMoveDown } = ChangeResumeOrder();

  const innerSectionClick = (e, index, action) => {
    if (action == "quill") {
      props.changeFocusStyle(props.sectionId, index.toString(), "item", true);
    } else {
      props.changeFocusStyle(props.sectionId, index.toString(), "item");
    }
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  let headerHtml;
  switch (props.sectionId) {
    case "projects":
      headerHtml = Project1;
      break;
    case "volunteering":
      headerHtml = Volunteer1;
      break;
    // case "onlinePresence":
    //   headerHtml = OnlinePresence1;
    //   break;
    case "certifications":
      headerHtml = Certifications1;
      break;
    // case "references":
    //   headerHtml = References1;
    //   break;
    case "publications":
      headerHtml = Publications1;
      break;
    // case "books":
    //   headerHtml = Books1;
    //   break;
    case "additionalExperience":
      headerHtml = AdditionalExperienceHeader1;
      break;
    // case "additionalSkills":
    //   headerHtml = AdditionalSkillsHeader1;
    //   break;
    // case "courses":
    //   headerHtml = CoursesHeader1;
    //   break;
    // case "industryExpertise":
    //   headerHtml = IndustryExpertiseHeader1;
    //   break;
    default:
      headerHtml = Project1;
      break;
  }

  // if (education.headerStyle == "Header1") {
  //   headerHtml = Header1;
  // } else if (education.headerStyle == "Header2") {
  //   headerHtml = Header2;
  // } else if (education.headerStyle == "Header3") {
  //   headerHtml = Header3;
  // } else {
  //   headerHtml = Header1;
  // }

  const mainSectionClick = (e, title) => {
    props.changeFocusStyle(props.sectionId, false, "section");
  };

  const handleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };
  //   useEffect(() => {
  //     setShowDatePicker(false);
  //   }, [props]);

  useEffect(() => {
    if (props.newSectionFocus != props.sectionId) {
      setShowDatePicker(false);
      setIsSelectedFrom(true);
    }
  }, [props.newSectionFocus]);

  const CommonName = (resumeHandler, resumeUpdate, response, index) => {
    return (
      response.showFields.name && (
        <>
          <div>
            <ContentEditable
              sectionId={sectionId}
              className={""}
              name="name"
              tagType="span"
              index={index}
              value={response.name}
              placeholder="Title"
              style={{
                fontFamily: styles.bodyFont,
                fontSize: styles.bodyFontSize,
              }}
              onChange={resumeHandler}
              onBlur={(e) => resumeUpdate(e)}
            />
          </div>
        </>
      )
    );
  };

  const CommonDate = (handleDatePicker, response, index) => {
    return (
      response.showFields.date && (
        <>
          <span className="">
            <span
              data-placeholder="From"
              className="p-0"
              style={{
                fontFamily: styles.bodyFont,
                fontSize: styles.bodyFontSize,
              }}
              onClick={() => handleDatePicker("from")}
            >
              {response &&
              response.dateRange &&
              response.dateRange.fromYear &&
              response &&
              response.dateRange &&
              response.dateRange.fromMonth
                ? `${response.dateRange.fromMonth} / ${response.dateRange.fromYear}`
                : response && response.dateRange && response.dateRange.fromYear
                ? response && response.dateRange && response.dateRange.fromYear
                : ""}
            </span>{" "}
            -{" "}
            <span
              data-placeholder="To"
              style={{
                fontFamily: styles.bodyFont,
                fontSize: styles.bodyFontSize,
              }}
              onClick={() => handleDatePicker("to")}
            >
              {response && response.dateRange && response.dateRange.isOnGoing
                ? response &&
                  response.dateRange &&
                  response.dateRange.onGoingText != ""
                  ? response &&
                    response.dateRange &&
                    response.dateRange.onGoingText
                  : "Ongoing"
                : response &&
                  response.dateRange &&
                  response.dateRange.toYear &&
                  response &&
                  response.dateRange &&
                  response.dateRange.toMonth
                ? `${response.dateRange.toMonth} / ${response.dateRange.toYear}`
                : response && response.dateRange && response.dateRange.toYear
                ? response && response.dateRange && response.dateRange.toYear
                : ""}
            </span>
          </span>
        </>
      )
    );
  };

  const CommonLocation = (response, index) => {
    return (
      response.showFields.location && (
        <>
          <ContentEditable
            sectionId={sectionId}
            className={"mb-0"}
            name="location"
            tagType="p"
            index={index}
            value={response.location}
            placeholder="Location"
            style={{
              fontFamily: styles.bodyFont,
              fontSize: styles.bodyFontSize,
            }}
            onChange={resumeHandler}
            onBlur={(e) => resumeUpdate(e)}
          />
        </>
      )
    );
  };

  const CommonOrganization = (response, index) => {
    return (
      response.showFields.organization && (
        <>
          <ContentEditable
            sectionId={sectionId}
            className={"mb-0"}
            name="organization"
            tagType="p"
            index={index}
            value={response.organization}
            placeholder="Organization"
            style={{
              fontFamily: styles.bodyFont,
              fontSize: styles.bodyFontSize,
            }}
            onChange={resumeHandler}
            onBlur={(e) => resumeUpdate(e)}
          />
        </>
      )
    );
  };

  const CommonPublishingCompany = (response, index) => {
    return (
      response.showFields.publishingCompany && (
        <>
          <ContentEditable
            sectionId={sectionId}
            className={"mb-0"}
            name="publishingCompany"
            tagType="p"
            index={index}
            value={response.publishingCompany}
            placeholder="Publishing Company / Journal"
            style={{
              fontFamily: styles.bodyFont,
              fontSize: styles.bodyFontSize,
            }}
            onChange={resumeHandler}
            onBlur={(e) => resumeUpdate(e)}
          />
        </>
      )
    );
  };
  const CommonAuthors = (response, index) => {
    return (
      response.showFields.authors && (
        <>
          <ContentEditable
            sectionId={sectionId}
            className={"mb-0"}
            name="authors"
            tagType="p"
            index={index}
            value={response.authors}
            placeholder="Authors / Co-authors"
            style={{
              fontFamily: styles.bodyFont,
              fontSize: styles.bodyFontSize,
            }}
            onChange={resumeHandler}
            onBlur={(e) => resumeUpdate(e)}
          />
        </>
      )
    );
  };

  const CommonCompany = (response, index) => {
    return (
      response.showFields.company && (
        <>
          <ContentEditable
            sectionId={sectionId}
            className={"mb-0"}
            name="company"
            tagType="p"
            index={index}
            value={response.company}
            placeholder="Company"
            style={{
              fontFamily: styles.bodyFont,
              fontSize: styles.bodyFontSize,
            }}
            onChange={resumeHandler}
            onBlur={(e) => resumeUpdate(e)}
          />
        </>
      )
    );
  };

  const CommonItem = (response, index, row) => {
    const replace = (domNode) => {
      if (domNode.attribs && domNode.attribs.class === "common-name") {
        return CommonName(resumeHandler, resumeUpdate, response, index);
      } else if (domNode.attribs && domNode.attribs.class === "common-date") {
        return CommonDate(handleDatePicker, response, index);
      } else if (
        domNode.attribs &&
        domNode.attribs.class === "common-location"
      ) {
        return CommonLocation(response, index);
      } else if (
        domNode.attribs &&
        domNode.attribs.class === "common-organization"
      ) {
        return CommonOrganization(response, index);
      } else if (
        domNode.attribs &&
        domNode.attribs.class === "common-publishingCompany"
      ) {
        return CommonPublishingCompany(response, index);
      } else if (
        domNode.attribs &&
        domNode.attribs.class === "common-authors"
      ) {
        return CommonAuthors(response, index);
      } else if (
        domNode.attribs &&
        domNode.attribs.class === "common-company"
      ) {
        return CommonCompany(response, index);
      }
    };
    return (
      <>
        <div
          className={`${props.sectionId}-item resume-item
                              ${
                                props.newSectionFocus == props.sectionId &&
                                props.currentStateFocus == "item" &&
                                props.newItemFocus &&
                                props.newItemFocus == index.toString()
                                  ? "sectionFocusStyle"
                                  : ""
                              }
                            `}
          id={`${props.sectionId}-${index}`}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            innerSectionClick(e, index);
          }}
        >
          {showQuillToolbar &&
            props.newSectionFocus == props.sectionId &&
            props.currentStateFocus == "item" &&
            props.newItemFocus &&
            props.newItemFocus == index.toString() && (
              <SectionItemToolbar
                index={index}
                indexString={index.toString()}
                handleDelete={props.handleItemDelete}
                addAdditionalField={props.addAdditionalField}
                sectionItemMoveUp={props.sectionItemMoveUp}
                sectionItemMoveDown={props.sectionItemMoveDown}
                row={row}
                sectionId={props.sectionId}
                startFrom={response.startFrom}
                endUntil={response.endUntil}
                resumeUpdate={resumeUpdate}
                dateHandler={dateHandler}
                showDatePicker={showDatePicker}
                newSectionFocus={props.newSectionFocus}
                isSelectedFrom={isSelectedFrom}
                response={response}
                changeSettings={props.changeSettings}
              />
            )}

          {parse(headerHtml, { replace })}
          {response &&
            response.showFields &&
            response.showFields.description && (
              <div className="education-description resume-description">
                <Quilleditor
                  type="visual"
                  showQuillToolbar={showQuillToolbar}
                  changesetShowQuillToolbar={changesetShowQuillToolbar}
                  theme="snow"
                  className={``}
                  inivalue={response?.description?.replace(/\n|\r/g, "")}
                  current={index}
                  setvalue={handleEditorChange}
                  onBlur={resumeUpdate}
                  styles={styles}
                  sectionId={props.sectionId}
                  placeholder="A varied project on your resume sums up the value that your learnings and background will bring to job"
                />
              </div>
            )}
        </div>
      </>
    );
  };
  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <>
            <div
              id={`${props.sectionId}-title`}
              className={
                settings && settings.showIcon
                  ? "d-flex education-title title-section"
                  : "education-title title-section"
              }
              style={{
                backgroundColor:
                  styles &&
                  styles.isTitleBackgroundColor &&
                  styles.isTitleBackgroundColor
                    ? styles.sectionTitleColor
                    : "unset",
              }}
            >
              {settings && settings.showIcon && (
                <span
                  style={{
                    marginTop: "auto",
                    color: styles.secondaryColor,
                  }}
                >
                  <i
                    className="fa fa-graduation-cap pr-2"
                    aria-hidden="true"
                    style={{
                      fontSize: styles.titleFontSize,
                    }}
                  ></i>
                </span>
              )}
              <ContentEditable
                sectionId={sectionId}
                name="customTitle"
                index="0"
                tagType="h5"
                className="section-title"
                value={
                  resumeFields.customTitle
                    ? t(`customTitle`, {
                        customTitle: resumeFields.customTitle,
                      })
                    : t(`${sectionId}.defaultTitle`)
                }
                placeholder="Title"
                onChange={resumeTitleHandler}
                onBlur={resumeUpdate}
                style={{
                  color: styles.primaryColor,
                  fontFamily: styles.titleFont,
                  fontSize: styles.titleFontSize,
                  fontWeight: styles.bold,
                }}
              />
            </div>
            <div
              className={`section-item-wrapper ${props.sectionId}-item-wrapper`}
            >
              {resumeFields &&
                resumeFields.data &&
                resumeFields.data.map((response, index, row) =>
                  CommonItem(response, index, row)
                )}
            </div>
          </>
        </>
      )}
    </>
  );
}
export default Project;
